import ApiService from "@/core/services/ApiService";

class GlobalService {

    public static update(resource, id, target, data) {
        ApiService.setHeader()
        return ApiService.put(`api/${resource}/${id}/${target}`,data)
    }

    public static get(resource, slug){
        ApiService.setHeader()
        return ApiService.get(resource, slug)
    }

    public static post(resource: string, params: any){
        ApiService.setHeader()
        return ApiService.post(`api/${resource}`, params)
    }

    public static delete(resource, slug, data?:any){
        ApiService.setHeader()
        return ApiService.delete(`api/${resource}`, slug, data)
    }

}

export default GlobalService;